<div mat-dialog-header class="title">
    Muckpile Management
</div>
<div mat-dialog-content>
    <div class="main-container">
        <!-- Active Muckpiles List -->
        <div class="muckpile-container container">
            <h2 class="muckpile-list-header">Active Muckpiles</h2>
            <div cdkDropList #activeList="cdkDropList" [cdkDropListData]="activeMuckpiles"
                [cdkDropListConnectedTo]="[inactiveList]" class="list" (cdkDropListDropped)="drop($event)">
                <div *ngIf="activeMuckpiles.length === 0 && !isUpdating" class="container centered-content">
                    <div class="container centered-content">
                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                        <div>No Data Found</div>
                    </div>
                </div>
                <div *ngIf="!isUpdating">
                    <div class="muckpile-name-box container font-small" *ngFor="let muckpile of activeMuckpiles;"
                        cdkDrag>
                        {{ muckpile.name }}
                    </div>
                </div>
                <div *ngIf="isUpdating" class="container centered-content">
                    <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                </div>
            </div>
        </div>

        <!-- Inactive Muckpiles List -->
        <div class="muckpile-container container">
            <h2 class="muckpile-list-header">Inactive Muckpiles</h2>
            <div cdkDropList #inactiveList="cdkDropList" [cdkDropListData]="inactiveMuckpiles"
                [cdkDropListConnectedTo]="[activeList]" class="list" (cdkDropListDropped)="drop($event)">
                <div *ngIf="inactiveMuckpiles.length === 0 && !isUpdating" class="container centered-content">
                    <div class="container centered-content">
                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                        <div>No Data Found</div>
                    </div>
                </div>
                <div *ngIf="isUpdating" class="container centered-content">
                    <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                </div>
                <div *ngIf="!isUpdating">
                    <div class="muckpile-name-box container font-small" *ngFor="let muckpile of inactiveMuckpiles"
                        cdkDrag>
                        {{ muckpile.name }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>